import React from 'react'
import styles from './LeftSidebar.scss'
import { CueList } from './CueList'
import { Distance, Elevation, Duration } from 'common/units'
import { FormattedMessage as T } from 'react-intl'
import cx from 'classnames'

export class LeftSidebar extends React.PureComponent {
  render () {
    const { route, cues, currentCue, cuePicked, className } = this.props

    const totalCues = cues.size
    const remainingCues = cues.filter(c => c.confirmed).size
    const percentCompleted = Math.floor(100 * remainingCues / totalCues)

    return (
      <div className={cx(styles.LeftSidebar, className)}>
        <div className={styles.routeInfo}>
          <div className={styles.routeName}>
            {route.name || 'Unnamed route'}
          </div>
          <div className={styles.routeMetrics}>
            <span><Distance value={route.metrics.distance} short bigUnits /></span>
            <span><Elevation value={route.metrics.ele_gain} short /></span>
            {route.metrics.estimatedTime && <span style={{ fontStyle: 'italic' }}><Duration value={route.metrics.estimatedTime} biggestUnits /></span>}
          </div>
        </div>
        <div className={styles.metrics}>
          <div className={styles.title}>
            <T id='LeftSidebar.reviewCuesheet' defaultMessage='Review Cuesheet' />
          </div>
          <T
            id='LeftSidebar.completedTotal'
            defaultMessage='{percentCompleted}% completed ({remainingCues} / {totalCues} cues)'
            values={{ percentCompleted, remainingCues, totalCues }} />
        </div>
        <CueList cues={cues} currentCue={currentCue} cuePicked={cuePicked} />
      </div>
    )
  }
}
